package gr.tech.site.pages.blog

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initLuckyleafrecapPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("blog/luckyleafrecap.md", FrontMatterElement.Builder { addScalar("title", "Lucky Leaf 2026 Recap | We're Lucky To Be Here"); addScalar("description", "From icy sidewalks to warm handshakes - Green Rebates recaps Lucky Leaf 2026, where Minnesota's cannabis optimism was at an all-time high and the Rebate Olympics handed out serious cash."); addScalar("author", "Ethan Cohen"); addScalar("date", "2026-03-09"); addScalar("updated", "2026-03-09"); addScalar("image", "/images/blog/luckyleaf2026.JPG"); addList("tags") { addScalar("Big Incentives"); addScalar("Big Rebates"); addScalar("Cost Savings"); }; }))
}

@Page("/blog/lucky-leaf-2026")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun LuckyleafrecapPage() {
    org.jetbrains.compose.web.dom.H2(attrs = { id("we-re-lucky-to-be-here") }) {
        org.jetbrains.compose.web.dom.Text("We’re Lucky To Be Here")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Oh Minnesota. I nearly died slipping on ice during my walk from the hotel to the convention center, and gosh darnit I’d do it again. There’s something special about freezing cold places with warm-hearted personalities. After all the traveling to Minneapolis over the last year, it’s safe to say it’s become our second home.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The Rebate Olympics were a success, giving out ${'$'}700 in cold hard cash to the bronze, silver, and gold medal winners each day. By the end of day two, a few folks were ready to compete in the Flappy Bird World Championships. We even saw a former boxer break the ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("“Payday Punch”")
        }
        org.jetbrains.compose.web.dom.Text(" record! To see the Rebate Olympics in action, head over to our ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://www.instagram.com/greenrebates/") {
            org.jetbrains.compose.web.dom.Text("Instagram page")
        }
        org.jetbrains.compose.web.dom.Text(" and check out the latest ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://www.instagram.com/p/DVblwuRDy0c/") {
            org.jetbrains.compose.web.dom.Text("Lucky Leaf recap")
        }
        org.jetbrains.compose.web.dom.Text(".")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("What really stood out at this trade show were the variety of conversations we had on our podcast and Man On The Street interviews. We talked with Lucy from ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://minneleaf.com/") {
            org.jetbrains.compose.web.dom.Text("MinneLeaf")
        }
        org.jetbrains.compose.web.dom.Text(" about her sex gummies, legacy grower ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://www.instagram.com/cat.gg_/") {
            org.jetbrains.compose.web.dom.Text("Cat Franklin")
        }
        org.jetbrains.compose.web.dom.Text(" about the days of selling seeds in CD cases, and Max Vannelli about becoming one of the youngest dispensary owners in the entire state. Heck, we even had an in-depth conversation with a man who specializes in bulletproof glass for dispensaries across the country. They didn’t let me shoot a gun at a piece of their glass, but they did give me free Skittles, so we’ll call it a draw.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Now that we can officially call ourselves trade show veterans, our mission at these events isn’t to aggressively sell ourselves—because honestly, our services speak for themselves. Instead, we ask questions, because everyone in the cannabis industry has a fascinating ")
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("“how I got here”")
        }
        org.jetbrains.compose.web.dom.Text(" story. What makes this industry so unique is that everyone in it genuinely believes in the product and its benefits. You can’t say the same about the CEO of McDonald’s, who probably looks like he needs to vomit every time he takes a bite of a Big Mac.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The most inspiring part of Lucky Leaf 2026 was the optimism about Minnesota’s market compared to last year. In 2025, cultivators were understandably frustrated as the OCM took its sweet time issuing licenses. This year, though, the excitement was palpable. The consensus among growers is that it’s only a matter of time before Minnesota becomes one of the most abundant cannabis markets in the country.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("To Minnesota cultivators—whether we chatted at Lucky Leaf or not—we’d love to talk with you about your facility. The rebates in Minnesota are some of the best in the country, and we’re the team that helps you secure the biggest check. We’ve helped get ")
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("over ${'$'}100 million in rebates approved")
        }
        org.jetbrains.compose.web.dom.Text(" for horticulture experts upgrading to energy-efficient LEDs, HVAC systems, dehumidifiers, controllers, and more.")
    }
    org.jetbrains.compose.web.dom.P {
        com.varabyte.kobweb.silk.components.navigation.Link("https://greenrebates.com/contact-us/") {
            org.jetbrains.compose.web.dom.B {
                org.jetbrains.compose.web.dom.Text("Upgrade your facility. Get paid")
            }
        }
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text(".")
        }
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Related:")
        }
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/blog/green-rebates-is-back-at-lucky-leaf") {
                org.jetbrains.compose.web.dom.Text("Green Rebates Is Back At Lucky Leaf!")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/article/the-2026-guide-to-cannabis-rebates-how-to-get-paid-for-your-grow-upgrades") {
                org.jetbrains.compose.web.dom.Text("The 2026 Guide to Cannabis Rebates: How to Get Paid for Your Grow Upgrades")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/article/cash-back-for-growers-a-step-by-step-roadmap-to-utility-incentives") {
                org.jetbrains.compose.web.dom.Text("Cash Back for Growers: A Step-by-Step Roadmap to Utility Incentives")
            }
        }
    }
}
